import { toast } from "react-toastify";
export function validatePhone(input_phone) {
   // return Boolean( String(input_phone).match(/^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/) );
   const pilotNumberRegex = /^[a-zA-Z0-9]{1,10}$/; // Allow alphanumeric characters up to 10 characters
   return pilotNumberRegex.test(input_phone);
}

export const validateEmail = (email) => {
   const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
   if (!email) {
     return "Email is required";
   } else if (!emailPattern.test(email)) {
     return "Invalid email format";
   }
   return "";
 };
 
export const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    const seconds = String(date.getSeconds()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const getCurrentTime = () => {
  const now = new Date();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  return `${hours}:${minutes}`;
};

export const getCurrentDate = () => {
  const today = new Date();
  const year = today.getFullYear();
  const month = String(today.getMonth() + 1).padStart(2, "0");
  const day = String(today.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
};

export const hasPermission = (
  moduleOperations,
  module,
  operation,
) => {

  return !!moduleOperations?.[module]?.[operation];
};

export const exportToCSV = ({
  data = [],
  fileName = "export",
  columns = [],
}) => {
  try {
    if (!data.length) return;

    const headers = columns.map(col => col.header);

    const rows = data.map(row =>
      columns.map(col => {
        let value =
          typeof col.accessor === "function"
            ? col.accessor(row)
            : row[col.accessor];

        value = value ?? "";
        return `"${String(value).replace(/"/g, '""')}"`;
      })
    );

    const csvContent = [headers, ...rows]
      .map(r => r.join(","))
      .join("\n");

    const blob = new Blob(
      [csvContent],
      { type: "text/csv;charset=utf-8;" }
    );

    const link = document.createElement("a");

    const url = URL.createObjectURL(blob);

    link.href = url;
    link.download = `${fileName}.csv`;

    document.body.appendChild(link);

    link.click();

    document.body.removeChild(link);

    URL.revokeObjectURL(url);

  } catch (err) {
    console.log("Export failed:", err);
    toast.error("Failed to export data. Please try again.");
  }
};